import React, { useEffect, useState } from 'react';
import { Badge, Button, Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import axios from 'axios';
import swal from 'sweetalert2';
import { toast } from 'react-toastify';  
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import idly from '../../../../images/items/idly.png';
import { Link } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_BASE_URL;


const WorkChecklist = ({ show, onClose, data  , onSuccess }) => {

        const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const [staffStatusMap, setStaffStatusMap] = useState({});

    useEffect(() => {
        if (data?.stagging_with_staff?.length > 0) {
            const init = {};
            data.stagging_with_staff.forEach(item => {
                // Checkbox should be checked if staff_status is 0   
                init[item.staff_id] = item.staff_status === 0;
            });
            setStaffStatusMap(init);
        }
    }, [data]);

    const handleCheckboxChange = (staffId) => {
        // Do nothing if checkbox is disabled
        const staff = data.stagging_with_staff.find(s => s.staff_id === staffId);
        if (staff?.staff_status === 0) return;

        setStaffStatusMap(prev => ({
            ...prev,
            [staffId]: !prev[staffId]
        }));
    };

    const handleSubmit = () => {
        const payload = {
            menumaker_date: data.workassignment_date,
            item: data.item,
            stagging_with_staff: data.stagging_with_staff.map(item => ({
                item_stagging_id: item.item_stagging_id,
                staff_id: item.staff_id,
                staff_status: staffStatusMap[item.staff_id] ? 0 : 1,
                description: item.description || '',
            }))
        };

        axios.post(`${baseURL}/work-assignment`, payload)
            .then(() => {
                // swal.fire("✅ Success", "Staff status updated successfully!", "success");
                 toast.success("Staff Work Status Updated Successfully!");
                                if (onSuccess) {
                                  onSuccess(); // e.g., trigger data refetch or update state
                                }
                                  onClose(); // Close modal or form
                // onClose();
            })
            .catch((err) => {
                console.error("Staff status update failed", err);
                swal.fire("❌ Error", err?.response?.data?.message || "Something went wrong!", "error");
            });
    };

    // Check if all staff already have status = 0
    const allStaffCompleted = data?.stagging_with_staff?.every(item => item.staff_status === 0);

    return (
        <Modal show={show} onHide={onClose} size="lg">
             <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Work Checklist</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                     <div className='row mb-2'>
                        <div className='col-lg-6 mb-2'>
                            <div className="d-flex align-items-center justify-content-start gap-2">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={data?.item_info?.image || idly} className='border rounded px-1 py-0'>
                                        <img src={data?.item_info?.image || idly} alt={data?.item_info?.name || 'Item Image'} className='cursor-pointer w-60px h-60px' />
                                    </div>
                                </LightGallery>
                                <div>
                                    <label className='text-danger font-w600 fs-5'>{data?.item_info?.name || '-'}</label>
                                    <div className="d-block">
                                        <label className="fs-7 text-dark">{data?.item_info?.category || '-'}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Qty / Units</label>
                            <label className='text-black fs-6 font-w500'>{data?.product_info?.cooking_quantity || 0}</label>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-lg-12 col-md-6 col-sm-6 mb-2'>
                            <div className='d-flex flex-row align-items-center justify-content-between gap-2'>
                                <div>
                                    <label className='font-w500 text-black fs-6'>Total Staff</label>
                                    <Badge bg='primary' className='text-white fs-7 py-0 px-1 ms-2 rounded'>  {data?.stagging_with_staff?.length || 0}</Badge>
                                </div>
                                <div>
                                    <label className='font-w500 text-black fs-6'>Total Duration</label>
                                    <Badge bg='none' className='text-danger fs-7 py-0 px-1 ms-2 rounded border border-danger'>
                                    {(() => {
                                    let totalSeconds = 0;

                                    (data?.stagging_with_staff || []).forEach(staff => {
                                        const time = staff.working_hours || "00h 00m 00s";
                                        const match = time.match(/(\d{2})h\s*(\d{2})m\s*(\d{2})s/);

                                        if (match) {
                                        const hours = parseInt(match[1], 10);
                                        const minutes = parseInt(match[2], 10);
                                        const seconds = parseInt(match[3], 10);
                                        totalSeconds += (hours * 3600) + (minutes * 60) + seconds;
                                        }
                                    });

                                    const totalHrs = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
                                    const totalMins = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
                                    const totalSecs = String(totalSeconds % 60).padStart(2, '0');

                                    return `${totalHrs}h ${totalMins}m ${totalSecs}s`;
                                    })()}
                                </Badge>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-lg-12 col-md-6 col-sm-6 mb-2'>
                            <div className="table-container"> 
                                <div
                                    style={{
                                        maxHeight: '300px',
                                        overflowY: 'auto',
                                        overflowX: 'hidden', // ⛔ explicitly block horizontal scroll
                                    }}
                                    >
                                <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"  style={{
                                    minHeight: '100px',
                                    width: '100%',        // Full width inside container
                                    tableLayout: 'fixed', // Prevent extra expansion
                                    }}>
                                    <thead>
                                          <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-25px text-center'></th>
                                             <th className='min-w-100px'>Staff Name </th>
                                            <th className='min-w-100px text-center'>Item Stagging</th>
                                            <th className='min-w-50px text-center'>Work Hour</th>
                                            <th className='min-w-50px text-center'>Work Score</th> 
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                        {data?.stagging_with_staff?.length > 0 ? (
                                            data.stagging_with_staff.map((staff) => (
                                                <tr key={`${staff.staff_id}_${staff.item_stagging_id}`}>
                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={staffStatusMap[staff.staff_id] || false}
                                                            onChange={() => handleCheckboxChange(staff.staff_id)}
                                                            disabled={staff.staff_status === 0} // checkbox is read-only if already 0
                                                        />
                                                    </td>
                                                    <td>
                                                        <label className='text-black font-w400 fs-7'>{staff.staff_name || '-'}</label>
                                                        <div className='d-block'>
                                                            <label className='text-dark font-w500 fs-8'>Master</label>
                                                        </div>
                                                    </td> 
                                                    <td className='text-center'>
                                                        <label className='text-black font-w400 fs-7'>{staff.itemstagging_name || '-'} {staff.item_stagging_id || '-'}</label>
                                                        <OverlayTrigger overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{staff.description || '-'}</span></Tooltip>} >
                                                            <i class="fa-solid fa-circle-info text-black fs-7 ms-2"></i>
                                                        </OverlayTrigger> 
                                                    </td> 
                                                    <td className='text-center'>
                                                        <label className='text-white font-w400 fs-7 py-1 px-2 rounded' style={{ backgroundColor: '#5f9ea0' }}>
                                                            {(() => {
                                                                const timeStr = staff.working_hours ?? "00h 00m 00s";
                                                                const match = timeStr.match(/(\d{2})h\s+(\d{2})m\s+(\d{2})s/);

                                                                if (match) {
                                                                const hours = parseInt(match[1], 10);
                                                                const minutes = parseInt(match[2], 10);
                                                                const decimalHours = (hours + minutes / 60).toFixed(1);
                                                                return `${decimalHours} hr`;
                                                                } else {
                                                                return "0.0 hr";
                                                                }
                                                            })()}
                                                            </label>

                                                    </td>
                                                    <td className='text-center'>
                                                        <label className='text-white font-w400 fs-7 py-1 px-1 rounded' style={{backgroundColor: '#f84518ff'}}>{staff.staff_score || '00'}</label>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center text-muted">
                                                    No staff assigned.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>

                 {/* {([4, 6].includes(parseInt(data?.workassignment_status)) && parseInt(data?.staff_status) === 5) && ( */}
    <div className="d-flex align-items-center justify-content-end gap-3 mt-5 mb-4">
        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>
        Submit Work Checklist
        <i className="fas fa-angle-double-right ms-2"></i>
        </Link>
    </div>
    {/* )} */}



                 {/* {[0, 1].includes(parseInt(data?.workassignment_status)) && (
                  <div className="d-flex align-items-center justify-content-end gap-3 mt-5 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Submit Work Checklist
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                    )} */}
 

                </div>
            </div>
        </Modal>
    );
};

export default WorkChecklist;

